var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIco5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 54",
    style: {
      enableBackground: "new 0 0 56 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.38,11.04h39.25c1.4,0,2.53-1.13,2.53-2.53c0-1.4-1.13-2.53-2.53-2.53H8.38c-1.4,0-2.53,1.13-2.53,2.53 C5.84,9.9,6.98,11.04,8.38,11.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.62,24.47H8.38c-1.4,0-2.53,1.13-2.53,2.53s1.13,2.53,2.53,2.53h39.25c1.4,0,2.53-1.13,2.53-2.53 S49.02,24.47,47.62,24.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.62,42.96H8.38c-1.4,0-2.53,1.13-2.53,2.53c0,1.4,1.13,2.53,2.53,2.53h39.25c1.4,0,2.53-1.13,2.53-2.53 C50.16,44.1,49.02,42.96,47.62,42.96z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco5);
export default __webpack_public_path__ + "static/media/gnb_ico5.9957a8e3a8d7ab7a635e072a6f6bd41a.svg";
export { ForwardRef as ReactComponent };